<!--
     <AutocompleteSelect
       :props="my_attrs_dictionary"
     />

     Public propertys:
       value → Gives the field's serializable value

     Accepted props:
     - items → [[value, text], [1, 'User 1']]
     - value
     - label
     - placeholder
     - multiple
-->

<template>
  <v-autocomplete
    v-model="props.value"
    :items="props.items"
    :label="props.label"
    :placeholder="props.placeholder"
    :multiple="props.multiple"
    :readonly="!!props.readonly"
    :item-text="props.item_text || '1'"
    :item-value="props.item_value || '0'"
    :rules="rules"
    :class="[props.class || props.readonly ? 'qmkey-form-input-readonly': 'qmkey-form-input', { required: props.required }]"
    outlined
    dense
    :clearable="!props.required && !props.readonly"
    :small-chips="props.chips"
    deletable-chips
    :disabled="!!props.disabled || !!props.readonly"
    @input="update"
  >
    <template v-slot:prepend-item v-if="props.multiple">
      <div class="v-list-item v-list-item--link theme--light" @click="selectAll(!select_all)" :class="select_all ? 'primary--text v-list-item--active' : ''">
        <div class="v-list-item__action">
          <v-icon>
            {{ select_all ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline' }}
          </v-icon>
        </div>
        <div class="v-list-item__content">
          {{ $t('select_all') }}
        </div>
      </div>
      <v-divider></v-divider>
    </template>
    <template>
      <v-icon slot="append" color="primary" v-if="!props.disabled && !props.readonly">
        {{ false || 'mdi-menu-down' }}
      </v-icon>
      <div v-else slot="append"></div> <!-- Hide icon -->
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  name: 'AutocompleteSelect',

  props: ['props'],

  data: () => ({
    valid: true,
    select_all: false,
  }),

  computed: {
    value() {
      let r = this.props.value || null
      if (
        this.props.value &&
        this.props.multiple &&
        this.props.value.length < 1
      ) {
        r = null
      }
      return r
    },
    rules() {
      // TODO: Multilang: Change hardcoded string
      return [(value) => !!value || !this.props.required || this.$vuetify.lang.translator('required_field')]
    },
  },

  mounted() {
    this.select_all = this.props.value.length == this.props.items.length;
  },

  methods: {
    validate() {
      // TODO: Show error message
      return this.valid
    },
    error_state(ok) {
      this.valid = ok
    },
    update(value) {
      let res = value;
      if (value && value.length <= 0) {
        res = null;
      }
      this.select_all = value && (value.length == this.props.items.length);
      this.$emit('update',res);
    },
    selectAll(all) {
      this.select_all = all;
      if (all) {
        this.update(this.props.items.map(([id,_]) => id));
      } else {
        this.update();
      }
    }
  },
}
</script>
<style lang="scss">
@import '@/sass/modalform.scss';
.theme--light.v-list-item:not(.v-list-item--active).v-list-item--highlighted::before{
  opacity: .0;
}
.theme--light.v-list-item.v-list-item--active.v-list-item--highlighted::before{
  opacity: .12 !important;
}
</style>
